import { atom } from 'recoil';

// Wether the drawer is open or not
export const runecraftingTabAtom = atom({ key: 'runecraftingTab', default: 'rune' as 'rune' | 'cloth' | 'affix' });
